import hasReportPrinting from "@/mixins/report/hasReportPrinting";

/**
 * Podnaslov štampe i Excela dobija i izabrane smene (kad nisu sve četiri), da se iz izvoza vidi šta je
 * filtrirano. Zahteva prop `shifts` (ili `selectedShifts`) i nasleđen stari tab sa `subtitle`.
 */
export default {
  computed: {
    subtitle() {
      const dates = hasReportPrinting.computed.subtitle.call(this);
      const shifts = this.selectedShifts || this.shifts || [];
      if (!shifts.length || shifts.length >= 4) {
        return dates;
      }
      return `${dates} · ${this.$t("shifts")}: ${[...shifts].sort((a, b) => a - b).join(", ")}`;
    },
  },
};
